export const PR_AGENCY_META_DESCRIPTION =
  "Perceptica equips PR agencies with media monitoring, media intelligence and crisis monitoring for clients across Southeast Europe. Partner with us.";
